<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M7 13h34a1.5 1.5 0 000-3H7a1.5 1.5 0 000 3zM41 22.5H7a1.5 1.5 0 000 3h34a1.5 1.5 0 000-3zM41 35H7a1.5 1.5 0 000 3h34a1.5 1.5 0 000-3z"/></svg>